export const tableConfig = {
    name: 'customerDetail',
    selection: false,
    index: false,
    height: 300,
    columns: [
        {
            label: '客户名称',
            prop: 'customerName'
        },
        {
            label: '行业大类',
            prop: 'industryCategoriesName'
        },
        {
            label: '行业类型',
            prop: 'industryType',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE'
        }
    ]
};
